import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object } from "yup";
import PURCHASEIRQVeteranView from "../views/IrqVeteranView";
import StatusCheck from "../components/StatusCheck";

class BuildIrqVeteranPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            isVeteran: bool().required(),
          })}
        >
          <PURCHASEIRQVeteranView
            content={contentMap.BuildIrqVeteranPage}
            navigationsAway={customNavigationMap.BuildIrqVeteranPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqVeteranPage);
